import React from 'react';
export function ServiceEntryPoint() {
  return <section className="w-full bg-white py-12 md:py-14 px-4 sm:px-6 lg:px-8 border-y border-gray-100" data-id="element-269" data-mp="1i6mpygn6yi2x">
      <div className="max-w-4xl mx-auto" data-id="element-270" data-mp="1biavkwx8jrdo">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10" data-id="element-271" data-mp="1q9s1l7wgz06r">
          Not sure if your team needs this?
        </h2>
        <p className="text-xl md:text-2xl text-brand-gray mb-12 leading-relaxed" data-id="element-272" data-mp="1lgz1ixby4g10">
          Start with a call. Tell me what's going on with your team and I'll
          tell you honestly whether I can help. If it makes sense, we can start
          with a team assessment to see where the gaps are. No commitment beyond
          that.
        </p>
        <a href="#/contact/book" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm" data-id="element-273" data-mp="249b0da3e4z6e">
          Book a Call
        </a>
      </div>
    </section>;
}